 

import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import queryString from 'query-string';
import { toast } from "react-toastify";

export default function Verify() {
    const [searchParams] = useSearchParams();
    const [mode, setMode] = useState(-1);


    useEffect(() => {
        //let params = queryString.parse(location.search);
        //console.log('params', params);
        const m=searchParams.get('mode');
        setMode(m);       
    }, []);

    return (
        <>

            <div className="container">
                <div className="row p-3">
                    <div className="col">
                        <div className={"alert " + (mode==1 || mode==4 || mode==5|| mode==3?"alert-danger"
                                                :mode==2?"alert-dark":"alert-success")} role="alert">
                            <h4 className="alert-heading">سامانه نورون</h4>
                            {mode == 1 && <p>درخواست پیدا نشد</p>}
                            {mode == 2 && <p>این پرداخت قبلا تایید شده است</p>}
                            {mode == 3 && <p>مبلغ پرداختی با مبلغ درخواست تطابق ندارد</p>}
                            {mode == 4 && <p>خطا در تایید پرداخت</p>}
                            {mode == 5 && <p>خطا در ثبت اطلاعات</p>}
                            {mode == 6 && <p>پرداخت شما ثبت شد و اعتبار شما افزایش پیدا کرد</p>}
                            <Link to="/" className="btn btn-primary" 
                            >بازگشت</Link>
                            <hr/>
                            <p className ="mb-0">در صورت هر گونه مشکل در عملیات بانکی با شرکت تماس حاصل فرمایید</p>
                        </div>
                        
                    </div>
                </div>

            </div>
        </>

    );

}
